import { defineStore } from 'pinia';

export const usePosProviderStore = defineStore('posProvider', {
  state: () => ({
    posProviderName: null,
  }),

  getters: {
    getPosProviderName: (state) => state.posProviderName,
    hasPosProvider: (state) => state.posProviderName !== null && state.posProviderName !== undefined,
  },

  actions: {
    /**
     * Initialize the POS provider from venue configuration
     * @param {Object} venueConfig - The venue configuration object
     */
    initFromVenueConfig(venueConfig) {
      if (venueConfig && venueConfig.posProvider) {
        this.posProviderName = venueConfig.posProvider;
      }
    },

    /**
     * Set the POS provider name directly
     * @param {string} providerName - The name of the POS provider
     */
    setPosProviderName(providerName) {
      this.posProviderName = providerName;
    },

    /**
     * Clear the POS provider information
     */
    clearPosProvider() {
      this.posProviderName = null;
    },

	isExternalPosProvider() {
		return this.posProviderName != null && this.posProviderName !== 'WEPOS';
	},
  },
});
